<template>
  <div
    id="boxDrop"
    :class="['box_drop',{ active : isShowDropBox, box_drop_layer : isLayer }]"
    :style="cssProps"
    @click.self="onClickDrop()"
    ref="boxDrop">
    <div class="inner_box_drop">
      <DatePickerCalendar
        :calendarData="calendarData"
        :value="getDropBoxValue"
        @onClickDay="onClickOption">
      </DatePickerCalendar>
    </div>
  </div>
</template>

<script>
import DatePickerCalendar from '@lemontree-ai/lemontree-admin-common-front/components/common/calendar/DatePickerCalendar';
import { convertDateFormat } from '@lemontree-ai/lemontree-admin-common-front/utils/dateUtils';
import { getDocumentElementPositon, getDocumentElementPopop } from '@lemontree-ai/lemontree-admin-common-front/utils/elementUtils';
import { isValidDate } from '@lemontree-ai/lemontree-admin-common-front/utils/validateUtils';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'DropBoxDate',
  components: {
    DatePickerCalendar
  },
  data(){
    return{
      isShowDropBox: false,
      calendarData: {
        targetMonth: '', // 월간 - 기준월 YYYY-MM
        searchDataRangeMonthly: { start_date:'', end_date:'' }, // 월간 조회 일
        limit: { minMonth:'', maxMonth:'', isMaxMonthToday:false, minDate:'', maxDate:'' },
        isRange: false,
      },
      spaceMargin: 8,
      dropBoxPosition:{
        width:0,
        top:0,
        bottom:0,
        left:0,
      },
      dropBoxHeight: 387,
      isLayer: false,
    }
  },
  beforeMount() {
    this.init();
  },
  beforeUnmount() {
    this.isShowDropBox = false;
    if (this.dropBoxActive) clearTimeout(this.dropBoxActive);
  },
  computed: {
    ...mapGetters('commonViewport', [ 'getWindowWidth', 'getWindowHeight', 'getScrollTop', 'getLayerScrollTop', 'getLayerBodyPosition' ]),
    ...mapGetters('commonDropBox', [ 'getDropBoxUid', 'getIsDateDropBox', 'getDropBoxDataList', 'getDropBoxTarget', 'getDropBoxTargetHeight', 'getDropBoxOption','getDropBoxSeletData', 'getDropBoxValue']),
    cssProps(){
      var obj = {};
      obj = {
        '--top': `${this.dropBoxPosition.top}${this.dropBoxPosition.top != 'inherit' ? 'px' : ''}`,
        '--bottom': `${this.dropBoxPosition.bottom}${this.dropBoxPosition.bottom != 'inherit' ? 'px' : ''}`,
        '--left': `${this.dropBoxPosition.left}px`,
      }
      return obj;
    },
    isInPopup(){
      return getDocumentElementPopop(this.getDropBoxTarget);
    }
  },
  watch:{
    getDropBoxUid(){
      if(this.getDropBoxUid === null) return;
      this.setDropBoxPosition();
      this.setScrollReset();
    },
    getIsDateDropBox(){
      if(this.getIsDateDropBox){
        this.setScrollReset();
      }
    },
    getWindowWidth(){
      this.setDropBoxPosition();
    },
    getWindowHeight(){
      this.setDropBoxPosition();
    },
    getScrollTop(){
      this.setDropBoxPosition();
    },
    getLayerScrollTop(){
      this.setDropBoxPosition();
    },
    getDropBoxTargetHeight(){
      this.setDropBoxPosition();
    },
    getDropBoxValue(){
      this.setValue();
    }
  },
  // update(){
  //   console.log('update',this.getDropBoxTarget.offsetHeight)
  // },
  methods:{
    ...mapActions('commonDropBox', [ 'fetchDropBoxSelect', 'fetchDropBoxEnd' ]),
    init(){
      if (this.getDropBoxOption) {
        this.calendarData.isRange = this.getDropBoxOption.isRange;
        this.calendarData.limit.minDate = this.getDropBoxOption.minDate;
        this.calendarData.limit.maxDate = this.getDropBoxOption.maxDate;
      }
      this.setValue();
      this.dropBoxActive();
      this.setDropBoxPosition();
    },
    dropBoxActive(){
      const _this = this;
      this.timeoutID0 = setTimeout(function(){
        _this.isShowDropBox = true;
        this.timeoutID0 = null;
      }, 50);
    },
    setScrollReset(){
      if(!this.$refs.scrollBody) return;
      this.$refs.scrollBody.scrollTop = 0;
    },
    setDropBoxPosition(){
      if(!this.getDropBoxTarget) return;
      const elementOffset = getDocumentElementPositon(this.getDropBoxTarget);
      const isInPopupScroll = -this.getLayerScrollTop + this.getScrollTop; // 팝업내에 있을 경우 scroll값 추가
      const dropBoxTop = this.getDropBoxTarget.offsetHeight + elementOffset.top; // 드롭박스 top 위치값

      // 선택영역 보이는 화면 벗어낫을때 닫기
      const targetTop = elementOffset.top + (this.isInPopup ? isInPopupScroll : 0);
      const targetBottom = dropBoxTop + (this.isInPopup ? isInPopupScroll : 0);
      const targetAreaTop = this.isInPopup ? this.getLayerBodyPosition.top : this.getScrollTop + 60;
      const targetAreaBottom = this.isInPopup ? this.getLayerBodyPosition.bottom : this.getWindowHeight+ this.getScrollTop;
      const targetOverflowTop = targetBottom < targetAreaTop;
      const targetOverflowBottom = targetTop > targetAreaBottom;
      // console.log(targetOverflowTop , targetOverflowBottom);
      // if(targetOverflowTop || targetOverflowBottom){
      //   this.fetchDropBoxEnd();
      // }

      // dropbox Position
      let top = dropBoxTop + this.spaceMargin + (this.isInPopup ? isInPopupScroll : 0);
      let bottom = this.getWindowHeight - elementOffset.top + this.spaceMargin - (this.isInPopup ? isInPopupScroll : 0);
      const left = elementOffset.left + this.getDropBoxTarget.offsetWidth - 322;

      const dropOverflowViewTop = this.getWindowHeight - bottom - this.getScrollTop - this.dropBoxHeight < 0;
      const dropOverflowViewBottom = this.getWindowHeight+ this.getScrollTop - top  - this.dropBoxHeight < 0;
      if(dropOverflowViewTop && dropOverflowViewBottom){
        // console.log('중간')
        top = 'inherit';
        bottom = bottom - (this.dropBoxHeight /2);
      }
      else if(!dropOverflowViewTop && dropOverflowViewBottom){
        // console.log('위')
        top = 'inherit';
        bottom = bottom;
      }
      else{
        // console.log('아래')
        top = top;
        bottom = 'inherit';
      }
      this.dropBoxPosition.top= top;
      this.dropBoxPosition.bottom= bottom;
      this.dropBoxPosition.left= left;
      this.dropBoxPosition.width= this.getDropBoxTarget.offsetWidth;
      this.isLayer = left < 0;
    },
    setValue(){
      // console.log(this.getDropBoxValue)
      const isValue = this.getDropBoxValue && isValidDate(this.getDropBoxValue) && !this.getDropBoxOption.isRange;
      const isValueRangeStart = this.getDropBoxValue[0] && isValidDate(this.getDropBoxValue[0]);
      const isValueRangeEnd = this.getDropBoxValue[1] && isValidDate(this.getDropBoxValue[1]);
      if (isValue) {
        this.calendarData.targetMonth = convertDateFormat(this.getDropBoxValue, 'YYYY-MM');
      }
      if (isValueRangeStart && this.getDropBoxOption.isRange) {
        this.calendarData.targetMonth = convertDateFormat(this.getDropBoxValue[0], 'YYYY-MM');
      }
    },
    onClickOption(option){
      this.fetchDropBoxSelect(option)
    },
    onClickDrop(){
      if(this.isLayer){
        this.fetchDropBoxEnd();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box_drop{position:absolute;overflow:hidden;top:var(--top);bottom:var(--bottom);left:var(--left);width:322px;z-index:300;max-height:0;opacity:0;transition:max-height 0.2s ease-in}
.inner_box_drop{padding:14px;border-radius:$CONTENT_RADIUS;border:1px solid $DEFAULT_BORDER;background-color:$FORM_BG;box-shadow:2px 4px 4px 0 rgba(0,0,0,.1)}

.area_empty{padding:28px 0}
.area_empty .desc_empty{color:#bbb;text-align:center}

.box_drop.active{overflow:visible;max-height:1000px;opacity:1;transition:max-height 0.5s ease-out, opacity 0.2s;}
.box_drop.active .inner_box_select{box-shadow:0 2px 6px rgba(0,0,0,.2)}

.box_drop.box_drop_layer{position:fixed;top:0;bottom:0;left:0;right:0;width:100%;backdrop-filter:blur(1px);background-color:$DIMMED_BG;height:100%;max-height:inherit}
.box_drop.box_drop_layer .inner_box_drop{position:absolute;bottom:0;left:0;right:0;width:100%;border:0 none;border-radius:10px 10px 0 0;box-sizing:border-box;background-color:$DEFAULT_BG}

@media (prefers-color-scheme: dark) {
  .inner_box_drop{border-color:$PRIMARY_COLOR;background-color:$FORM_BG_DARK}
  .btn_option:disabled{background-color:$DISABLED_BG_DARK;color:$DISABLED_TEXT_DARK}
  .btn_option .icon_check ::v-deep g{fill:$PRIMARY_COLOR}

  .box_drop.box_drop_layer{background-color:$DIMMED_BG_DARK}
  .box_drop.box_drop_layer .inner_box_drop{background-color:$DEFAULT_BG_DARK}
}
</style>